// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"oF","contentFrame":"oG","buttonGroup":"oH","button":"oI","header":"oJ","text":"oK","contentImage":"oL","closeButton":"oM"};